import { getPermissions as _getPermissions } from '@flowus/common/block/permissions';
import { segmentsToText } from 'src/editor/utils/editor';
import { SHARE_CACHES } from 'src/redux/middlewares/cache-lift';
import { cache, getState } from 'src/redux/store';
import type { RootState } from 'src/redux/types';
import { useObservableStore } from 'src/services/rxjs-redux/hook';
import { $spacesCache } from 'src/services/spaces/spaces';
import { $currentUserCache } from 'src/services/user/current-user';
import { judgeSharePage } from 'src/utils/getPageId';
import { getCurrentSpace } from '../space';
import { useStore } from 'react-redux';
export { ROLE_WEIGHT } from '@flowus/common/block/type';

// uuid 为必填参数
export const usePermissions = (
  uuid?: string,
  opt?: {
    wait?: number;
    waitMode?: 'debounce' | 'throttle';
  }
) => {
  const { wait, waitMode = 'throttle' } = opt ?? {};
  const defaultWait = wait === undefined ? (uuid && cache.blocks[uuid] ? 800 : 50) : wait;
  const store = useStore();

  return useObservableStore(
    ({ blocks }) => getPermissions(uuid, { ...(store.getState() as RootState), blocks }),
    [uuid],
    { wait: defaultWait, waitMode, useRx: true }
  );
};

export const getPermissions = (uuid?: string, state?: RootState) => {
  if (!state) {
    state = getState();
  }

  const shareCache = SHARE_CACHES.getShare(uuid ?? '');
  if (uuid != null && shareCache) {
    return shareCache;
  }

  const result = _getPermissions(
    {
      ...state,
      user: $currentUserCache,
      permissionGroups: getCurrentSpace().permissionGroups,
      segmentsToText,
      isSharePage: judgeSharePage(),
      spaces: $spacesCache,
    },
    uuid
  );

  if (uuid != null) {
    SHARE_CACHES.setShare(uuid, result);
  }

  return result;
};
